import { useToast } from '@plaidev/sour-react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { IAuthRepository } from '../../../repository/Api/Auth/interface';
import { repositoryGetter } from '../../../repository/container';

const repository = repositoryGetter.Auth();
const getInitialAuthInfoQueryKey = ['/auth/get-initial-auth-info'] as const;
const getBootstrapQueryKey = ['/global-navi/get-bootstrap-v2'] as const;

type Variables = IAuthRepository.RevokeActiveGrant.Params;
type Params = {
  onSuccess?: (grant: Awaited<ReturnType<IAuthRepository.RevokeActiveGrant>>, variables: Variables) => void;
  onError?: (variables: Variables) => void;
  onSettled?: () => void;
};
type Result = {
  revokeActiveGrant: (params: Variables) => void;
  isRevokingActiveGrant: boolean;
  revokingActiveGrantKey?: Variables['grantKey'];
};

export const _revokeActiveGrant = ({ onSuccess, onError, onSettled }: Params = {}): Result => {
  const toast = useToast();
  const queryClient = useQueryClient();
  const {
    mutate: revokeActiveGrant,
    isPending,
    variables,
  } = useMutation({
    mutationFn: async (params: Variables) => repository.revokeActiveGrant(params),
    onSuccess: async (grant, variables) => {
      await queryClient.invalidateQueries({ queryKey: getInitialAuthInfoQueryKey });
      await queryClient.invalidateQueries({ queryKey: getBootstrapQueryKey });
      onSuccess?.(grant, variables);
    },
    onError: (_error, variables) => {
      toast.error('権限を無効化できませんでした');
      onError?.(variables);
    },
    onSettled,
  });

  return { revokeActiveGrant, isRevokingActiveGrant: isPending, revokingActiveGrantKey: isPending ? variables?.grantKey : undefined };
};
